import { api } from "@/lib/api";

// Loads the Cashfree v3 JS SDK once.
let sdkPromise = null;
function loadSdk() {
  if (typeof window !== "undefined" && window.Cashfree) return Promise.resolve();
  if (sdkPromise) return sdkPromise;
  sdkPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://sdk.cashfree.com/js/v3/cashfree.js";
    s.async = true;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error("Failed to load payment SDK"));
    document.body.appendChild(s);
  });
  return sdkPromise;
}

// Creates a Cashfree order server-side, then launches hosted checkout.
// The browser is redirected to Cashfree and returns to /payment-return.
export async function startCashfreePurchase({ packageId, propertyId }) {
  const { data } = await api.post("/payments/cashfree/create-order", {
    package_id: packageId,
    property_id: propertyId || null,
    origin_url: window.location.origin,
  });
  await loadSdk();
  const cashfree = window.Cashfree({ mode: data.mode === "production" ? "production" : "sandbox" });
  await cashfree.checkout({
    paymentSessionId: data.payment_session_id,
    redirectTarget: "_self",
  });
  return data;
}
